import React from "react";
import {
  X, Pencil, Trash2, Smile, Frown, Meh,
  AlertTriangle, Lightbulb, Fingerprint, MessageSquare, Radio,
} from "lucide-react";

const sentimentLabel = (score) => {
  if (score == null) return null;
  if (score > 0.3) return { text: "Positive", cls: "green" };
  if (score < -0.3) return { text: "Negative", cls: "red" };
  return { text: "Neutral", cls: "yellow" };
};

const JourneyDetailPanel = ({ step, onClose, onEdit, onDelete }) => {
  if (!step) return null;

  const sentiment = sentimentLabel(step.sentimentScore);

  return (
    <>
      <div className="plm-detail-overlay" onClick={onClose} />
      <div className="plm-detail-panel">
        <div className="plm-detail-header">
          <h3>Step #{step.stepOrder} — {step.phaseName || "Unnamed"}</h3>
          <button className="plm-btn-ghost" onClick={onClose} style={{ padding: "4px 6px" }}>
            <X size={18} />
          </button>
        </div>

        <div className="plm-detail-body">
          {/* Phase & Channel */}
          <div className="plm-detail-section">
            <div className="plm-detail-section-title">Phase</div>
            <div className="plm-detail-value">{step.phaseName || "—"}</div>
          </div>

          {step.channel && (
            <div className="plm-detail-section">
              <div className="plm-detail-section-title">
                <Radio size={12} style={{ marginRight: 4 }} /> Channel
              </div>
              <div className="plm-detail-value">{step.channel}</div>
            </div>
          )}

          {/* Touchpoint */}
          {step.touchpoints && (
            <div className="plm-detail-section">
              <div className="plm-detail-section-title">
                <Fingerprint size={12} style={{ marginRight: 4 }} /> Touchpoint
              </div>
              <div className="plm-detail-value">{step.touchpoints}</div>
            </div>
          )}

          {/* User Action */}
          {step.userAction && (
            <div className="plm-detail-section">
              <div className="plm-detail-section-title">User Action</div>
              <div className="plm-detail-value">{step.userAction}</div>
            </div>
          )}

          {/* Thoughts & Feelings */}
          {step.thoughtsFeelings && (
            <div className="plm-detail-section">
              <div className="plm-detail-section-title">
                <MessageSquare size={12} style={{ marginRight: 4 }} /> Thoughts & Feelings
              </div>
              <div className="plm-detail-value">{step.thoughtsFeelings}</div>
            </div>
          )}

          {/* Emotion */}
          {step.emotion && (
            <div className="plm-detail-section">
              <div className="plm-detail-section-title">Emotion</div>
              <div className="d-flex align-items-center gap-2">
                <span className={`plm-badge ${sentiment?.cls || "gray"}`}>
                  {step.emotion}
                </span>
                {step.sentimentScore != null && (
                  <span style={{ fontSize: "0.78rem", color: "var(--plm-text-muted)" }}>
                    Score: {step.sentimentScore.toFixed(2)}
                  </span>
                )}
              </div>
              {step.effortScore != null && (
                <div style={{ marginTop: 6 }}>
                  <span style={{ fontSize: "0.75rem", color: "var(--plm-text-muted)" }}>Effort: </span>
                  <div className="plm-sentiment-bar-track" style={{ display: "inline-block", width: 100, verticalAlign: "middle" }}>
                    <div
                      className="plm-sentiment-bar-fill"
                      style={{
                        width: `${step.effortScore * 100}%`,
                        background: step.effortScore > 0.6 ? "var(--plm-danger)" : step.effortScore > 0.3 ? "var(--plm-warning)" : "var(--plm-success)",
                      }}
                    />
                  </div>
                  <span style={{ fontSize: "0.75rem", marginLeft: 6, color: "var(--plm-text-muted)" }}>
                    {(step.effortScore * 100).toFixed(0)}%
                  </span>
                </div>
              )}
            </div>
          )}

          {/* Pain Point */}
          {step.painPoint && (
            <div className="plm-detail-section">
              <div className="plm-detail-section-title">
                <AlertTriangle size={12} style={{ marginRight: 4, color: "var(--plm-danger)" }} /> Pain Point
              </div>
              <div className="plm-cell-chip pain" style={{ display: "inline-flex" }}>
                {step.painPoint}
              </div>
            </div>
          )}

          {/* Opportunity */}
          {step.opportunity && (
            <div className="plm-detail-section">
              <div className="plm-detail-section-title">
                <Lightbulb size={12} style={{ marginRight: 4, color: "#b45309" }} /> Opportunity
              </div>
              <div className="plm-cell-chip opportunity" style={{ display: "inline-flex" }}>
                {step.opportunity}
              </div>
            </div>
          )}
        </div>

        <div className="plm-detail-footer">
          <button className="plm-btn-primary" onClick={() => onEdit(step)}>
            <Pencil size={14} /> Edit
          </button>
          <button className="plm-btn-ghost danger" onClick={() => onDelete(step)}>
            <Trash2 size={14} /> Delete
          </button>
        </div>
      </div>
    </>
  );
};

export default JourneyDetailPanel;
